module.exports = __webpack_public_path__ + "static/iphone-frame-d2e10ba3c2c2989a1e94db01a6200afe.png";